<div class="ui-g fondo">
    <div class="ui-g-2 ui-sm-1">
    </div>
    <div class="ui-g-8 ui-sm-12">
        <section class="beneficios">
            <div class="contenedor-beneficios"> 
                    <div class="descripcion">
                        <div class="form">
                            <div class="titulo-center"><h2 class="titulo">Formulario de solicitud RPN para empresa</h2></div>
                            <script src="https://tecnisegurosmkt.activehosted.com/f/embed.php?id=15" type="text/javascript" charset="utf-8"></script>    
                            <iframe class="form-inside" width="100%" height="950" src="../../assets/enterprise.html"> </iframe>
                        </div>
                    </div>
            </div>
        </section>
    </div>
    <div class="ui-g-2 ui-sm-1"></div>    
</div>


